export const DEFAULT_APP_LANGUAGE = "uz-Latn";
export const LANGUAGE_COOKIE_NAME = "edu_game_locale";

export type AppLanguage = "ru" | "uz-Latn";

const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

function isAppLanguage(value: string): value is AppLanguage {
  return value === "ru" || value === "uz-Latn";
}

export function readLanguageCookie(cookieHeader: string): AppLanguage | null {
  for (const part of cookieHeader.split(";")) {
    const [rawName, ...rawValueParts] = part.split("=");
    if (rawName?.trim() !== LANGUAGE_COOKIE_NAME) {
      continue;
    }

    try {
      const value = decodeURIComponent(rawValueParts.join("=").trim());
      return isAppLanguage(value) ? value : null;
    } catch {
      return null;
    }
  }

  return null;
}

export function getInitialAppLanguage(): AppLanguage {
  if (typeof document === "undefined") {
    return DEFAULT_APP_LANGUAGE;
  }

  return readLanguageCookie(document.cookie) ?? DEFAULT_APP_LANGUAGE;
}

export function buildLanguageCookie(language: AppLanguage, secure: boolean) {
  const secureAttribute = secure ? "; Secure" : "";

  return `${LANGUAGE_COOKIE_NAME}=${encodeURIComponent(language)}; Path=/; Max-Age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secureAttribute}`;
}

export function persistAppLanguage(language: AppLanguage) {
  if (typeof document === "undefined") {
    return;
  }

  const secure = typeof location !== "undefined" && location.protocol === "https:";
  document.cookie = buildLanguageCookie(language, secure);
}
